import React from 'react';
import { Col, Container, Row } from '@gjensidige/core-grid';
import { Title } from '@gjensidige/core-typography';
import { useCmsContext } from '@gjensidige/service-cms';
import Navigation from '@gjensidige/service-navigation';

import { AppStep } from '../types/enums';
import { useCheckListContext } from '../context/CheckListProvider';
import styles from './Layout.module.scss';

interface LayoutProps {
  children: React.ReactNode;
}

interface LayoutContentProps {
  clickable?: boolean;
}

export const LayoutContent = ({ clickable }: LayoutContentProps) => {
  const { getText } = useCmsContext();
  const { setAppStep } = useCheckListContext();

  return (
    <>
      {process.env.NODE_ENV === 'development' && <Navigation />}
      <Row flexClass="justify-content-center">
        <Col md={6} className={styles.textContainer}>
          {clickable ? (
            <a
              onClick={() => setAppStep(AppStep.START)}
              className={styles.clickAble}
            >
              <Title tag="h1" size="h2">
                {getText('housing.check.title')}
              </Title>
            </a>
          ) : (
            <Title tag="h1" size="h2">
              {getText('housing.check.title')}
            </Title>
          )}

          <Title tag="h2" size="h3">
            {getText('housing.check.subTitle')}
          </Title>
        </Col>
      </Row>
    </>
  );
};

const Layout = ({ children }: LayoutProps) => {
  return (
    <>
      <Container className={styles.container}>
        <LayoutContent />
        {children}
      </Container>
    </>
  );
};

export default Layout;
